import moment from 'moment-timezone';

const parseDateTime = (text, format) => {
	if (text) {
		if (format) {
			return moment(text, format).toDate();
		} else {
			return new Date(text);
		}
	}
	return new Date();
};

const groupBy = (array, prop) => {
	return array.reduce((groups, item) => {
		const val = item[prop];
		groups[val] = groups[val] || [];
		groups[val].push(item);
		return groups;
	}, {});
};

const filter = (object, predicate) => {
	if (!object) {
		return {};
	}

	const result = {};
	for (const key in object) {
		if (predicate(object[key])) {
			result[key] = object[key];
		}
	}
	return result;
};

const convertToUserTime = (fixedCenterTime, center) => {
	const centerTimeZone = (center && center.timeZone) || moment.tz.guess();
	const currentTimeZone = moment().tz() || moment.tz.guess();	 // get user's time zone, set as default in moment-timezone

	return moment(fixedCenterTime)
		.tz(centerTimeZone, true)	// actual start time in center's time zone
		.tz(currentTimeZone);	// convert to user's time zone
}

const calculateDistance = (lat1, lon1, lat2, lon2) => {
	const R = 6371; // Earth's radius in kilometers
	const dLat = (lat2 - lat1) * Math.PI / 180;
	const dLon = (lon2 - lon1) * Math.PI / 180;
	const a =
		Math.sin(dLat / 2) * Math.sin(dLat / 2) +
		Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
		Math.sin(dLon / 2) * Math.sin(dLon / 2);
	const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
	return R * c;
};

const findClosestCenters = (selectedCenter, allCenters, maxDistance = 5, count = 5) => {
	if (!selectedCenter || !selectedCenter.latitude || !selectedCenter.longitude) {
		return [];
	}

	return allCenters
		.filter(center => center.id !== selectedCenter.id && center.latitude && center.longitude)
		.map(center => ({
			...center,
			distance: calculateDistance(
				selectedCenter.latitude,
				selectedCenter.longitude,
				center.latitude,
				center.longitude
			)
		}))
		.filter(center => center.distance <= maxDistance) // only include centers within maxDistance km
		.sort((a, b) => a.distance - b.distance)
		.slice(0, count);
};

export default {
	parseDateTime,
	groupBy,
	filter,
	convertToUserTime,
	calculateDistance,
	findClosestCenters
};